import styled from 'styled-components/macro';

import { ButtonBox } from 'components/base/CountryDropdown';
import { MenuButton } from 'components/base/Menu/index';
import { MenuList } from './../base/Menu/Menu';
import { ButtonWrapper } from './../base/Dropdown/shared/styles';
import Box from 'components/elements/Box';

export const Container = styled.section<{ short?: boolean }>`
  margin: 0.5em;
  padding: 0 1.5em;
  background: white;

  @media screen and (min-width: 50em) {
    width: ${({ theme }): string => `${theme.layout.smallScreen * 100}%`};
    margin: ${({ theme, short }): string =>
      short
        ? `0 auto ${theme.spacing.medium}`
        : `${theme.spacing.medium} auto`};
  }

  @media screen and (min-width: 80em) {
    width: ${({ theme }): string => `${theme.layout.largeScreen * 100}%`};
  }

  @media screen and (max-width: 48em) {
    padding: 0 1em;
  }
`;

export const TitleBar = styled.header<{
  isNotPadded?: boolean;
  isMobile?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: ${({ theme }): string => `0 ${theme.spacing.small}`};
  ${({ isMobile }): string => (isMobile ? 'flex-direction: column;' : '')}

  color: ${({ theme }): string => theme.NightBlue};
  padding-bottom: ${({ isNotPadded, isMobile }): any =>
    isNotPadded && isMobile && '0.2em !important'};

  @media screen and (max-width: 40em) {
    padding: ${({ theme }): string => `${theme.spacing.small} 0`};
  }
`;

export const Title = styled.h2<{
  isMobile?: boolean;
}>`
  flex-basis: auto;
  margin: ${({ theme, isMobile }): string =>
    `${isMobile ? theme.spacing.medium : theme.spacing.large} 1em ${
      isMobile ? '24px 0.6em' : '0 0'
    }`};
  font-size: 24px;
  font-weight: 700;
`;

export const AddCertificateButton = styled('button')<any>`
  appearance: none;
  color: ${({ theme }): string => theme.White};
  background-color: ${({ theme }): string => theme.AccentGreen};
  font-weight: 600;
  font-size: 16px;
  height: 43px;
  padding: ${({ theme }): string =>
    `${theme.spacing.small} ${theme.spacing.large}`};
  border: 0;
  border-radius: 4px;

  ${({ isMobile }): string =>
    isMobile
      ? `
    margin: 0;
    width: auto;
  `
      : `
    margin: 0.5em 0;
    width: fit-content;
  `}

  &:disabled {
    opacity: 0.5;
  }
`;

export const EditCertificateButton = styled(AddCertificateButton)`
  color: ${({ theme }): string => theme.AccentGreen};
  background-color: ${({ theme }): string => theme.White};
  border: 1px solid ${({ theme }): string => theme.AccentGreen};
`;

export const InfoMessage = styled.span`
  font-size: 16px;
  line-height: 23px;
  color: ${({ theme }): string => theme.NightBlue};
  padding: ${({ theme }): string => `${theme.spacing.small} 0`};
`;

export const EmptyBoxWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 360px;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 40em) {
    min-height: 300px;
  }
`;

export const EmptyBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  @media screen and (max-width: 40em) {
    ${Title} {
      margin-top: 1em;
    }
  }
`;

export const CountryElement = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    margin-top: -1px;
    margin-right: 20px;
  }

  svg {
    position: relative;
    left: -2px;
    margin-right: 16px;
  }

  @media screen and (max-width: 40em) {
    align-items: flex-start;

    img {
      margin-top: 3px;
    }

    svg {
      margin-top: 2px;
    }
  }
`;

export const CertificationList = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 1em;
  padding: ${({ theme }): string =>
    `${theme.spacing.xlarge} ${theme.spacing.medium}`};

  @media screen and (max-width: 48em) {
    padding: ${({ theme }): string =>
      `${theme.spacing.xlarge} ${theme.spacing.small}`};
  }

  @media screen and (max-width: 40em) {
    padding: ${({ theme }): string =>
      `${theme.spacing.small} ${theme.spacing.small}`};
  }
`;

export const CertificateItem = styled.div<any>`
  display: flex;
  flex-direction: ${({ isConfirmationShown }): string =>
    isConfirmationShown ? 'column' : 'row'};
  justify-content: space-between;
  ${({ isConfirmationShown }): string =>
    isConfirmationShown &&
    `
    align-items: center;
    gap: 4px;
    justify-content: center;
  `}
  flex-basis: 46%;
  flex-grow: 1;
  max-width: 46%;
  padding: ${({ theme, isConfirmationShown }): string =>
    `${isConfirmationShown ? '2px' : theme.spacing.medium} ${
      theme.spacing.xsmall
    }`};
  line-height: 1;
  border-bottom: 1px solid #eaedef;
  align-items: center;
  min-height: 56px;

  @media screen and (max-width: 45em) {
    flex-basis: 100%;
    max-width: 100%;
  }

  @media screen and (max-width: 40em) {
    flex-basis: 100%;
    max-width: 100%;

    flex-direction: column;
    ${({ isConfirmationShown }): string =>
      isConfirmationShown ? '' : 'align-items: flex-start;'}
    line-height: 18.75px;

    &:last-of-type {
      border-bottom: none;
    }
  }
`;

export const CertificationTypeSection = styled.div<any>`
  text-align: end;
  white-space: nowrap;
  margin-left: ${({ theme }): string => theme.spacing.xsmall};

  @media screen and (max-width: 40em) {
    margin-top: ${({ theme }): string => theme.spacing.small};
    margin-left: ${({ isEditMode }): string =>
      isEditMode ? '4.2em' : '2.3em'};
  }
`;

// Modal
export const ModalContent = styled('div')<any>`
  padding: ${({ theme }): string =>
    `${theme.spacing.xlarge} ${theme.spacing.xxlarge}`};
  @media screen and (max-width: 36rem) {
    padding: ${({ theme }): string => theme.spacing.medium};
  }

  ${ButtonBox} {
    background-color: ${({ theme }): string => theme.Sand};
    padding: 0.55rem 1rem;
    align-items: center;

    > div:first-of-type {
      display: flex;
      align-items: center;
      padding-bottom: 2px;
    }
  }

  .react-datepicker-wrapper {
    width: 100%;
    & input {
      background-color: ${({ theme }): string => theme.Sand};
      border: none;
      padding: 0.75rem;
      font-size: 16px;
      color: ${({ theme }): string => theme.DeepBlue};
      font-family: 'Proxima Nova';
      width: 100%;
      font-weight: 600;

      &::placeholder {
        color: ${({ theme }): string => theme.CasperGrey};
        font-weight: normal;
      }

      &:focus-visible {
        outline: none;
      }
    }
  }

  ${MenuButton} {
    text-align: left;
  }

  ${MenuList} {
    max-height: 220px;
  }

  ${ButtonWrapper} {
    padding: 0.55rem 1rem;

    > svg {
      color: ${({ theme }): string => theme.NightBlue};
    }
  }

  @media screen and (max-width: 40em) {
    ${AddCertificateButton} {
      width: 80%;
    }
  }
`;

export const H1 = styled('h1')`
  font-size: 1.5em;
  margin-bottom: 0.42em;
  @media screen and (max-width: 36rem) {
    margin-bottom: 0;
  }
`;

export const DropdownLabel = styled('span')`
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }): string => theme.CasperGrey};
  letter-spacing: 1px;
`;

export const CertificationSection = styled(Box)`
  width: 47%;

  @media screen and (max-width: 40em) {
    width: 100%;
  }
`;

export const QuantityAndTypeWrapper = styled.div`
  display: flex;
  margin-top: 1.5rem;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (max-width: 40em) {
    flex-direction: column;

    ${CertificationSection} {
      &:nth-child(2) {
        margin-top: 1.5rem;
      }
    }
  }
`;

export const ControlsContainer = styled('div')<any>`
  display: flex;
  ${({ isMobile }): string =>
    isMobile
      ? `
    flex-direction: column-reverse;
    width: 100%;
    gap: 8px;
  `
      : 'gap: 14px;'}
  ${({ isEmpty }): string => isEmpty && 'margin-bottom: 20px;'}
`;

export const RemoveButton = styled('div')`
  & > svg {
    display: block;
    width: 14px;
    height: 14px;

    & > g > g {
      fill: ${({ theme }): string => theme.AccentGreen};
    }
  }
`;

export const ConfirmQuestion = styled('span')`
  display: block;
  font-size: 13px;
  line-height: 15px;
  color: #000a29;
`;

export const ButtonsWrapper = styled('div')`
  display: flex;
  gap: 7px;
  margin-bottom: 1px;
`;

export const DeleteButton = styled('button')`
  appearance: none;
  color: ${({ theme }): string => theme.White};
  background-color: ${({ theme }): string => theme.AccentGreen};
  font-size: 13px;
  padding: 5px 15.5px;

  border: 1px;
  border-radius: 4px;
  width: fit-content;
`;

export const CancelButton = styled(DeleteButton)`
  color: ${({ theme }): string => theme.AccentGreen};
  background-color: ${({ theme }): string => theme.White};
  border: 1px solid ${({ theme }): string => theme.AccentGreen};
  padding: 5px 26.76px;
`;
